import * as React from "react";
import { Link } from "react-router-dom";

export const Home = (): React.JSX.Element => {
  return (
    <div>
      <h1>Welcome to Nurse Test</h1>
      <p>
        Click <Link to="/test">here</Link> to start the test.
      </p>
    </div>
  );
};
